import { PhxTooltipPlacement } from 'phx-core';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export type Theme = 'sementic' | 'ant' | 'new-groups';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'collapsible-list',
  styleUrls: ['./collapsible-list.component.scss'],
  templateUrl: './collapsible-list.component.html',
})
export class CollapsibleListComponent implements OnChanges {
  @Input() public list: string[];
  @Input() public position: PhxTooltipPlacement = 'top';
  @Input() public label: string;
  @Input() public isLabelDotted: boolean = false;
  @Input() public wrapItems: boolean = false;
  @Input() public theme?: Theme = 'sementic';
  @Input() public className?: string;
  @Input() public maxItems: number = 20;
  @Input() public pluralText?: string = $localize`groups`;
  @Input() public maxItemCount: number | undefined = undefined;
  @Output() public onClick = new EventEmitter();

  public firstItem: string;
  public subList: string[];
  public labelMapping: {[k: string]: string};
  public maxedList: string[];
  public ngOnChanges(changes: SimpleChanges) {
    const { list, label } = changes;

    if (list && list.currentValue) {
      this.firstItem = list.currentValue[0];
      this.subList = list.currentValue.slice(1);
      if (typeof this.maxItemCount === 'number' && list.currentValue.length > this.maxItemCount) {
        this.maxedList = list.currentValue.slice(0, this.maxItemCount);
        const remainingItems = list.currentValue.length - this.maxItemCount;
        this.maxedList.push('+' + remainingItems + ' ' + this.pluralText);
      } else {
        this.maxedList = list.currentValue;
      }
    }

    if (label && label.currentValue) {
      this.labelMapping = { '=1': label.currentValue, 'other': label.currentValue + 's' };
    }
  }

  public clicked(): void {
    this.onClick.emit();
  }
}
